import { useState } from "react";
import { Button, Card, List } from "antd";
import AddCommentModal from "./components/AddCommentModal";
import Item from "./components/Item";

const Comments = ({
  issue_id,
  data,
  refetch,
  gray = false,
  maxHeight = 320,
}) => {
  const [is_open_add_comment_modal, setIsOpenAddCommentModal] = useState(false);

  return (
    <Card
      styles={{
        header: gray
          ? {
              backgroundColor: "rgba(0, 0, 0, 0.02)",
            }
          : {},
        body: {
          padding: "0 24px",
          maxHeight,
          overflowY: "scroll",
        },
      }}
      style={{ marginBottom: 24 }}
      title={`Komentarze ${data?.length > 0 ? `(${data.length})` : ""}`}
      extra={
        <Button type="primary" onClick={() => setIsOpenAddCommentModal(true)}>
          Dodaj
        </Button>
      }
    >
      {is_open_add_comment_modal && (
        <AddCommentModal
          issue_id={issue_id}
          refetch={refetch}
          handleClose={() => setIsOpenAddCommentModal(false)}
        />
      )}
      <List
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item) => <Item {...item} refetch={refetch} />}
      />
    </Card>
  );
};

export default Comments;
